import axiosInstance from '../../lib/api/axiosInstance';
import { CalendarEvent, CalendarPreference } from '../../types';

// Define response type to fix TypeScript error
interface CalendarEventsResponse {
  events: CalendarEvent[];
}

export const getCalendarEvents = async (startDate: Date, endDate: Date): Promise<CalendarEvent[]> => {
  try {
    console.log(`Fetching calendar events from ${startDate.toISOString()} to ${endDate.toISOString()}`);
    
    const response = await axiosInstance.get<CalendarEventsResponse>('/google/calendar/events', {
      params: {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
      }
    });
    
    console.log('Calendar API response:', response.data);
    
    // Now TypeScript knows that response.data has an events property
    const events = response.data.events || [];
    
    // Make sure each event has a calendarId
    return events.map(event => ({
      ...event,
      calendarId: event.calendarId || 'primary' // Set default value if not provided
    }));
  } catch (error) {
    console.error('Erreur lors de la récupération des événements:', error);
    throw error;
  }
};

export const getCalendarList = async () => {
  try {
    const response = await axiosInstance.get('/google/calendar/list');
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des calendriers:', error);
    throw error;
  }
};

export const saveCalendarPreferences = async (selectedCalendarIds: string[]): Promise<CalendarPreference> => {
  try {
    const response = await axiosInstance.post<CalendarPreference>('/google/calendar/preferences', { selectedCalendarIds });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement des préférences:', error);
    throw error;
  }
};
